module.exports = __webpack_public_path__ + "img/google-social.1651d8b8.svg";